import request from '@/api/request.js'

// 登录
export function SystemAdminLogin(data) {
    return request({
        url: '/api/admin/systemadminlogin',
        method: 'post',
        data: data
    })
}

// 验证
export function SystemAdminVerify(data) {
    return request({
        url: '/api/admin/systemadminverify',
        method: 'post',
        data: data
    })
}

// 修改
export function SystemAdminModify(data) {
    return request({
        url: '/api/admin/systemadminmodify',
        method: 'post',
        data: data
    })
}

// 新增
export function SystemAdminInsert(data) {
    return request({
        url: '/api/admin/systemadmininsert',
        method: 'post',
        data: data
    })
}

// 删除
export function SystemAdminDelete(id) {
    return request({
        url: `/api/admin/systemadmindelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function SystemAdminUpdate(id, data) {
    return request({
        url: `/api/admin/systemadminupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function SystemAdminGetById(id) {
    return request({
        url: `/api/admin/getsystemadminbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function SystemAdminGetList(params) {
    return request({
        url: '/api/admin/getsystemadminlist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function SystemAdminGetPageList(params) {
    return request({
        url: '/api/admin/getsystemadminpagelist',
        method: 'get',
        params: params
    })
}